import type { GetStaticProps, NextPage } from 'next';

import { REVALIDATE_DEFAULT } from 'constants/revalidate';
import { featureToggles } from 'utils/featureToggles';
import { getChapteredSubPageContent } from 'content/queries/getChapteredSubPageContent';
import { ChapteredSubPageView } from 'components/views/ChapteredSubPageView';
import { ChapteredSubPageContent } from 'types/contentful/Pages/ChapteredSubPageContent';

const COMMITMENT_PAGE_ID = '6B46VTLVq5z9ejx3Ha6fie';

interface Props {
  content: ChapteredSubPageContent;
}

const DEICommitmentPage: NextPage<Props> = ({ content }) => (
  <>
    <ChapteredSubPageView title="Our Commitment" content={content} />
  </>
);

export const getStaticProps: GetStaticProps<Props> = async () => {
  const content = await getChapteredSubPageContent(COMMITMENT_PAGE_ID);
  if (!content) {
    throw new Error(
      `Could not get ChapteredSubPage by id "${COMMITMENT_PAGE_ID}"`
    );
  }
  return {
    props: {
      content,
    },
    notFound: !featureToggles.DEIPages,
    revalidate: REVALIDATE_DEFAULT,
  };
};

export default DEICommitmentPage;
